$('.option').click(function(){
    if (isDoubleClicked($(this))) return;
    toggleActive($(this));
});

function isDoubleClicked(element) {
    if (element.data("isclicked")){
        return true
    }
    element.data("isclicked", true);
    setTimeout(function () {
        element.removeData("isclicked");
    }, 1000);
    
    return false;
}

$(`.option`).hover(function(){
    if($(this).hasClass('active')) {
        return;
    }
    $(this).css("background-image", "linear-gradient(rgba(0, 0, 0, 0.8),rgba(0, 0, 0, 0.8)), url("+  $(this).data("url") +")");
}, function() {
    if($(this).hasClass('active')) {
        return;
    }
    $(this).css("background-image", "url("+  $(this).data("url") +")");
});

$('.option').focus(function(){
    $(".option").removeClass("active");
    $(this).addClass("active");
});


$(".label__cta").focus(function(){
    nestedAnchorFocus($(this))
});

function toggleActive(elm) {
    $(".slider-card").find(".info__button").addClass("none-events");
    $(elm).parent().find(".option").removeClass("active");
    $(elm).parent().find(".option").each(function() {
        $(this).css("background-image", "url("+  $(this).data("url") +")");
    });
    elm.addClass("active");
    elm.css("background-image", "linear-gradient(rgba(0, 0, 0, 0.8),rgba(0, 0, 0, 0.8)), url("+  elm.data("url") +")");
    const id = elm.prop('id');
    const points = $(elm).parent().siblings()[0];
    const list = $(points).find(".slider-card__dot").toArray()
    const element = list.filter(x => x.getAttribute('data-pos') === id)
    $(list).removeClass("indicator");
    $(element).addClass("indicator");
    $(elm).find(".info__button").removeClass("none-events");
}
function nestedAnchorFocus(elm) {
    toggleActive(elm.closest('.option'));
}


$(".slider-card__dot").click(function(event){
    const target = event.target;
    const card = $(target).parent().siblings()[0];
    const id = $(this).attr('data-pos');
    const elem = $(card).find("#" + id);
    toggleActive(elem);
});
